import { AccountTabScreenBoundary } from '@/src/components/navigation/AccountTabScreenBoundary'
import { useAppSession } from '@/src/contexts/AppSessionContext'
import { SubscriptionRequiredPlaceholder } from '@/src/features/paywall/components/SubscriptionRequiredPlaceholder'
import StatisticsScreen from '@/src/features/statistics/screens/StatisticsScreen'

export default function StatisticsTab() {
  const { hasPurchased } = useAppSession()

  if (!hasPurchased) {
    return <SubscriptionRequiredPlaceholder />
  }

  return (
    <AccountTabScreenBoundary>
      <StatisticsScreen />
    </AccountTabScreenBoundary>
  )
}
